import { AbpHttpInterceptor, RefreshTokenService } from '@abp/abpHttpInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';

@NgModule({
    providers: [
        ApiServiceProxies.TermMappingsServiceProxy,        
        ApiServiceProxies.BillTokensServiceProxy,
        ApiServiceProxies.ContactWalletsServiceProxy,
        ApiServiceProxies.CashOutsServiceProxy,
        ApiServiceProxies.RegulatVouchersServiceProxy,
        ApiServiceProxies.PlanCurrenciesServiceProxy,
        ApiServiceProxies.FlowerCrownBranchsServiceProxy,
        ApiServiceProxies.BillReportsServiceProxy,
        ApiServiceProxies.CommodityGroupsServiceProxy,
        ApiServiceProxies.FinancialYearsServiceProxy,
        ApiServiceProxies.StockHandlingDetailsServiceProxy,
        ApiServiceProxies.StockHandlingsServiceProxy,
        ApiServiceProxies.TransactionTypesServiceProxy,
        ApiServiceProxies.TransactionDetailsServiceProxy,
        ApiServiceProxies.FamilyIncomeOutcomesServiceProxy,
        ApiServiceProxies.IncomeOutcomesServiceProxy,
        ApiServiceProxies.AccountsServiceProxy,
        ApiServiceProxies.StockTransactionsServiceProxy,
        ApiServiceProxies.CommodityBasketDetailsServiceProxy,
        ApiServiceProxies.CommodityBasketsServiceProxy,
        ApiServiceProxies.BranchCommoditiesServiceProxy,
        ApiServiceProxies.CommoditiesServiceProxy,
        ApiServiceProxies.VoucherDetailsServiceProxy,
        ApiServiceProxies.PersonInquiriesServiceProxy,
        ApiServiceProxies.ServiceVouchersServiceProxy,
        ApiServiceProxies.ServiceConditionsServiceProxy,
        ApiServiceProxies.ConditionsServiceProxy,
        ApiServiceProxies.ServicesServiceProxy,
        ApiServiceProxies.FamilyTypesServiceProxy,
        ApiServiceProxies.NotifyJobsServiceProxy,
        ApiServiceProxies.CommentsServiceProxy,
        ApiServiceProxies.CardTemplateValuesServiceProxy,
        ApiServiceProxies.CardTemplatePropertiesServiceProxy,
        ApiServiceProxies.CardTemplatesServiceProxy,
        ApiServiceProxies.PosesServiceProxy,
        ApiServiceProxies.PosUsersServiceProxy,
        ApiServiceProxies.SMSServiceConfigsServiceProxy,
        ApiServiceProxies.BillSlaughteredsServiceProxy,
        ApiServiceProxies.SlaughteredsServiceProxy,
        ApiServiceProxies.NewslettersServiceProxy,
        ApiServiceProxies.SlaughterAgentsServiceProxy,
        ApiServiceProxies.NotificationKeysServiceProxy,
        ApiServiceProxies.SacrificeTypesServiceProxy,
        ApiServiceProxies.LegalContactsServiceProxy,
        ApiServiceProxies.FollowUpsServiceProxy,
        ApiServiceProxies.BranchDirectionsServiceProxy,
        ApiServiceProxies.FamilySupportOrganizationsServiceProxy,
        ApiServiceProxies.WizardStepsServiceProxy,
        ApiServiceProxies.HealthStatusesServiceProxy,
        ApiServiceProxies.BillPaymentsServiceProxy,
        ApiServiceProxies.PlanBillsServiceProxy,
        ApiServiceProxies.VisitCountsServiceProxy,
        ApiServiceProxies.PaymentsServiceProxy,
        ApiServiceProxies.NoticesServiceProxy,
        ApiServiceProxies.PostmanTasksServiceProxy,
        ApiServiceProxies.CondolenceMessagesServiceProxy,
        ApiServiceProxies.BillsServiceProxy,
        ApiServiceProxies.CeremoniesServiceProxy,
        ApiServiceProxies.EventTypesServiceProxy,
        ApiServiceProxies.DeceasedsServiceProxy,
        ApiServiceProxies.LocationsServiceProxy,
        ApiServiceProxies.LocationTypesServiceProxy,
        ApiServiceProxies.LocationGroupsServiceProxy,
        ApiServiceProxies.TemplateDatasServiceProxy,
        ApiServiceProxies.GeneralSettingsServiceProxy,
        ApiServiceProxies.ThemTemplatesServiceProxy,
        ApiServiceProxies.DocumentsServiceProxy,
        ApiServiceProxies.MoneyBoxEventsServiceProxy,
        ApiServiceProxies.TagsServiceProxy,
        ApiServiceProxies.MoneyBoxesServiceProxy,
        ApiServiceProxies.FlowerCrownsServiceProxy,
        ApiServiceProxies.SacrificesServiceProxy,
        ApiServiceProxies.PlanConstsServiceProxy,
        ApiServiceProxies.BannersServiceProxy,
        ApiServiceProxies.BaseTimesServiceProxy,
        ApiServiceProxies.CurrenciesServiceProxy,
        ApiServiceProxies.ConsumesAndSourcesServiceProxy,
        ApiServiceProxies.ConsumesServiceProxy,
        ApiServiceProxies.SourcesServiceProxy,
        ApiServiceProxies.AttributeValuesServiceProxy,
        ApiServiceProxies.AttributesServiceProxy,
        ApiServiceProxies.UserEntityValuesServiceProxy,
        ApiServiceProxies.UserEntitiesServiceProxy,

        ApiServiceProxies.PlanCategoriesServiceProxy,
        ApiServiceProxies.CharityPlansServiceProxy,
        ApiServiceProxies.BankAccountsServiceProxy,
        ApiServiceProxies.BanksServiceProxy,
        ApiServiceProxies.AmbassadorsServiceProxy,
        ApiServiceProxies.FamilyMembersRolesServiceProxy,
        ApiServiceProxies.FamilyMembersServiceProxy,
        ApiServiceProxies.FamiliesServiceProxy,
        ApiServiceProxies.SupportiveOrganizationsServiceProxy,
        ApiServiceProxies.EmployeesServiceProxy,
        ApiServiceProxies.GroupSubgroupsServiceProxy,
        ApiServiceProxies.ContactsServiceProxy,
        ApiServiceProxies.AddressesServiceProxy,
        ApiServiceProxies.EducationFieldsServiceProxy,
        ApiServiceProxies.BranchesServiceProxy,
        ApiServiceProxies.FamiliaritiesServiceProxy,
        ApiServiceProxies.RouteFeesServiceProxy,
        ApiServiceProxies.WagesServiceProxy,
        ApiServiceProxies.UniversitiesServiceProxy,
        ApiServiceProxies.EducationDegreesServiceProxy,
        ApiServiceProxies.JobsServiceProxy,
        ApiServiceProxies.RespectPrefixesServiceProxy,
        ApiServiceProxies.IntroductionMethodsServiceProxy,
        ApiServiceProxies.PointsServiceProxy,
        ApiServiceProxies.DirectionsServiceProxy,
        ApiServiceProxies.AreasServiceProxy,
        ApiServiceProxies.CitiesServiceProxy,
        ApiServiceProxies.StatesServiceProxy,
        ApiServiceProxies.CountriesServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
